import { render, staticRenderFns } from "./userMes.vue?vue&type=template&id=705c358d&scoped=true"
import script from "./userMes.vue?vue&type=script&lang=js"
export * from "./userMes.vue?vue&type=script&lang=js"
import style0 from "./userMes.vue?vue&type=style&index=0&id=705c358d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705c358d",
  null
  
)

export default component.exports